// C2 투척형 몹 투사체 풀(고정 용량 SoA). 렌더는 shared/mobRoles.ts MobShotsView 필드만 읽는다.
// 나머지(출발점·경과·경고 슬롯 기하 사본·피해)는 판정용 내부 상태다. 프레임 안에서 객체를 만들지 않는다.
import { MOB_SHOT_CAPACITY, type MobShotsView } from "../shared/mobRoles";

export class MobShots implements MobShotsView {
  readonly alive = new Uint8Array(MOB_SHOT_CAPACITY);
  readonly x = new Float32Array(MOB_SHOT_CAPACITY);
  readonly y = new Float32Array(MOB_SHOT_CAPACITY);
  readonly z = new Float32Array(MOB_SHOT_CAPACITY);
  readonly prevX = new Float32Array(MOB_SHOT_CAPACITY);
  readonly prevY = new Float32Array(MOB_SHOT_CAPACITY);
  readonly prevZ = new Float32Array(MOB_SHOT_CAPACITY);
  readonly progress = new Float32Array(MOB_SHOT_CAPACITY);
  readonly targetX = new Float32Array(MOB_SHOT_CAPACITY);
  readonly targetZ = new Float32Array(MOB_SHOT_CAPACITY);
  readonly role = new Uint8Array(MOB_SHOT_CAPACITY);
  readonly gen = new Uint16Array(MOB_SHOT_CAPACITY);
  // 판정용 내부 상태
  readonly startX = new Float32Array(MOB_SHOT_CAPACITY);
  readonly startZ = new Float32Array(MOB_SHOT_CAPACITY);
  /** 세계 틱 단위 경과(세계 배율을 그대로 더한다) */
  readonly elapsed = new Float32Array(MOB_SHOT_CAPACITY);
  readonly flight = new Uint16Array(MOB_SHOT_CAPACITY);
  /** 선딜 길이(경고 데칼 tick 이어 세기용) */
  readonly lead = new Uint16Array(MOB_SHOT_CAPACITY);
  /** 경고 슬롯 번호와 발사 순간 슬롯 기하 사본(슬롯이 다른 경고에 재사용됐는지 가린다) */
  readonly tele = new Int8Array(MOB_SHOT_CAPACITY).fill(-1);
  readonly cx = new Float32Array(MOB_SHOT_CAPACITY);
  readonly cz = new Float32Array(MOB_SHOT_CAPACITY);
  readonly cr = new Float32Array(MOB_SHOT_CAPACITY);
  readonly damage = new Float32Array(MOB_SHOT_CAPACITY);
  /** 던진 몹이 정예였는지(맞히면 지역 상태 이상) */
  readonly elite = new Uint8Array(MOB_SHOT_CAPACITY);
  readonly owner = new Int16Array(MOB_SHOT_CAPACITY).fill(-1);

  /** 빈 슬롯 번호(없으면 -1). 세대를 올려 돌려준다 */
  alloc(): number {
    for (let s = 0; s < MOB_SHOT_CAPACITY; s++) {
      if (this.alive[s] === 0) { this.gen[s] = (this.gen[s] + 1) & 0xffff; return s; }
    }
    return -1;
  }
  hasFree(): boolean { for (let s = 0; s < MOB_SHOT_CAPACITY; s++) if (this.alive[s] === 0) return true; return false; }
  /** 날아가는 투사체 수 */
  count(): number { let n = 0; for (let s = 0; s < MOB_SHOT_CAPACITY; s++) n += this.alive[s]; return n; }
  /** 영웅이 던진 몹의 소유 번호를 가진 날아가는 투사체 수 */
  ownedBy(i: number): number { let n = 0; for (let s = 0; s < MOB_SHOT_CAPACITY; s++) if (this.alive[s] !== 0 && this.owner[s] === i) n++; return n; }
  copyPrevious(): void {
    for (let s = 0; s < MOB_SHOT_CAPACITY; s++) { this.prevX[s] = this.x[s]; this.prevY[s] = this.y[s]; this.prevZ[s] = this.z[s]; }
  }
}
